// ============================================================================
// FILE: src/modules/uploads/components/wizard/ValidateStep.jsx
// MODULE: Generic Upload Framework
//
// PURPOSE:
// Display validation result returned by backend.
//
// RESPONSIBILITIES
// - Show validation summary
// - Show validation statistics
// - Show first validation errors
// - Allow error file download
// - Allow re-upload
// - Allow import
//
// NOTES
// - No validation logic.
// - No business rules.
// - No API calls except Download Error File.
// ============================================================================
//
// AUTHOR:
// DizyPro ERP Development Team
// ============================================================================

import React from "react";

import uploadService
    from "../../services/uploadService";


// ============================================================================
// Component
// ============================================================================

const ValidateStep = ({

    wizard,

    onImport,

    onReUpload

}) => {

    // ======================================================================
    // Validation Result
    // ======================================================================

    const validation =

        wizard.upload?.validation;

    if (!validation) {

        return (

            <div
                className="alert alert-warning"
            >

                Validation result not available.

            </div>

        );

    }

    // ======================================================================
    // Download Error File
    // ======================================================================

    const handleDownloadErrors =
        async () => {

            await uploadService
                .downloadErrorFile(

                    wizard.upload.job.id

                );

        };

    // ======================================================================
    // Render
    // ======================================================================

    return (

        <div className="card shadow-sm border-0">

            <div className="card-header bg-white">

                <h5 className="mb-0">

                    Validation Result

                </h5>

            </div>

            <div className="card-body">

                {/* ====================================================== */}
                {/* Upload Summary                                         */}
                {/* ====================================================== */}

                <table className="table table-bordered">

                    <tbody>

                        <tr>

                            <th width="30%">

                                Upload Job

                            </th>

                            <td>

                                {

                                    wizard.upload.job
                                        .job_number

                                }

                            </td>

                        </tr>

                        <tr>

                            <th>

                                File

                            </th>

                            <td>

                                {

                                    wizard.selectedFile
                                        ?.name

                                }

                            </td>

                        </tr>

                    </tbody>

                </table>

                {/* ====================================================== */}
                {/* Statistics                                             */}
                {/* ====================================================== */}

                <table className="table table-bordered">

                    <tbody>

                        <tr>

                            <th>

                                Total Rows

                            </th>

                            <td>

                                {

                                    validation.total_rows

                                }

                            </td>

                        </tr>

                        <tr>

                            <th>

                                Passed

                            </th>

                            <td>

                                {

                                    validation.valid_rows

                                }

                            </td>

                        </tr>

                        <tr>

                            <th>

                                Failed

                            </th>

                            <td>

                                {

                                    validation.failed_rows

                                }

                            </td>

                        </tr>

                        <tr>

                            <th>

                                Warnings

                            </th>

                            <td>

                                {

                                    validation.warning_rows

                                }

                            </td>

                        </tr>

                    </tbody>

                </table>

                {/* ====================================================== */}
                {/* Error Summary                                          */}
                {/* ====================================================== */}

                {

                    validation.error_summary?.length > 0 && (

                        <>

                            <h6>

                                Error Summary

                            </h6>

                            <table
                                className="table table-sm"
                            >

                                <thead>

                                    <tr>

                                        <th>

                                            Error

                                        </th>

                                        <th>

                                            Count

                                        </th>

                                    </tr>

                                </thead>

                                <tbody>

                                    {

                                        validation
                                            .error_summary
                                            .map(

                                                (row,index)=>(

                                                    <tr
                                                        key={index}
                                                    >

                                                        <td>

                                                            {
                                                                row.message
                                                            }

                                                        </td>

                                                        <td>

                                                            {
                                                                row.count
                                                            }

                                                        </td>

                                                    </tr>

                                                )

                                            )

                                    }

                                </tbody>

                            </table>

                        </>

                    )

                }

                {/* ====================================================== */}
                {/* First Errors                                           */}
                {/* ====================================================== */}

                {

                    validation.first_errors?.length > 0 && (

                        <>

                            <h6>

                                First Errors

                            </h6>

                            <table
                                className="table table-bordered"
                            >

                                <thead>

                                    <tr>

                                        <th>

                                            Row

                                        </th>

                                        <th>

                                            Column

                                        </th>

                                        <th>

                                            Message

                                        </th>

                                    </tr>

                                </thead>

                                <tbody>

                                    {

                                        validation
                                            .first_errors
                                            .map(

                                                (row,index)=>(

                                                    <tr
                                                        key={index}
                                                    >

                                                        <td>

                                                            {
                                                                row.row_number
                                                            }

                                                        </td>

                                                        <td>

                                                            {
                                                                row.column_name
                                                            }

                                                        </td>

                                                        <td>

                                                            {
                                                                row.message
                                                            }

                                                        </td>

                                                    </tr>

                                                )

                                            )

                                    }

                                </tbody>

                            </table>

                        </>

                    )

                }

                {/* ====================================================== */}
                {/* Actions                                                */}
                {/* ====================================================== */}

                <div
                    className="d-flex justify-content-between mt-4"
                >

                    <div>

                        <button

                            className="btn btn-outline-danger me-2"

                            onClick={

                                handleDownloadErrors

                            }

                        >

                            Download Error File

                        </button>

                        <button

                            className="btn btn-secondary"

                            onClick={

                                onReUpload

                            }

                        >

                            Re-upload

                        </button>

                    </div>

                    <button

                        className="btn btn-primary"

                        disabled={

                            validation.failed_rows > 0

                        }

                        onClick={

                            onImport

                        }

                    >

                        Import

                    </button>

                </div>

            </div>

        </div>

    );

};

export default ValidateStep;